import { Pipe, PipeTransform } from '@angular/core';
import { capitalize, startCase } from 'lodash';

@Pipe({
  name: 'sentenceCase',
})
export class SentenceCasePipe implements PipeTransform {
  transform(value: string): string {
    return capitalize(startCase(value));
  }
}
